import { Component, OnInit } from "@angular/core";
import { AlertMessageService, CurrentPagePipe, LoadingService, Page } from "@serpro/ngx-suite-rfb";
import { appRoute } from "src/app/shared/consts/app-routes";
import { Assunto } from "src/app/shared/model/assunto.model";
import { AtoConsulta } from "src/app/shared/model/ato-consulta.model";
import { Ato } from "src/app/shared/model/ato.model";
import { BuscaAto } from "src/app/shared/model/busca-ato.model";
import { Orgao } from "src/app/shared/model/orgao.model";
import { TipoAto } from "src/app/shared/model/tipo-ato.model";
import { AssuntoService } from "src/app/shared/services/assunto.service";
import { AtoService } from "src/app/shared/services/ato.service";
import { OrgaoService } from "src/app/shared/services/orgao.service";
import { TipoAtoService } from "src/app/shared/services/tipo-ato.service";
import { DataUtil } from "src/app/shared/util/data.util";

@Component({
    selector: 'app-gerir-atos',
    templateUrl: './gerir-atos.component.html',
    styleUrls: ['./gerir-atos.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class GerirAtosComponent implements OnInit {

    filtro: BuscaAto;

    tiposAto: TipoAto[];
    listaTipoAtoSelecionada: TipoAto[];

    pesquisaAvancada = false;

    // Ordenação
    listaVazia: AtoConsulta[] = [];

    sortedBy: (boolean | undefined)[] = [undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined];
    sortedColumn: string[] = ['idAto', 'tipoAto', 'numeroAto', 'orgaos', 'dataAto', 'dataPublicacao', 'publicado', 'internet', 'flags']

    atosOriginais: AtoConsulta[];
    atos: AtoConsulta[];

    labelsAssunto: string[];
    assuntos: Assunto[];
    listaAssuntosSelecionados: Assunto[];

    orgaos: Orgao[];
    listaOrgaosSelecionados: Orgao[];
    listaAreasResponsaveisSelecionadas: Orgao[];

    exibirEmentaTela = false;

    // Paginação
    pageSize = 100;
    currentPage: Page = { first: 0, last: this.pageSize, number: 1 };

    constructor(
        private tipoAtoService: TipoAtoService,
        private atoService: AtoService,
        private alertMessageService: AlertMessageService,
        private loadingService: LoadingService,
        private assuntoService: AssuntoService,
        private orgaoService: OrgaoService,
    ) {}

    ngOnInit(): void {
        document.title = 'Gerir atos';
        this.filtro = new BuscaAto();
        this.carregarTiposAto();
        this.carregarAssuntos();
        this.carregarOrgaos();
    }

    private carregarTiposAto() {
        this.tipoAtoService.getTodos().subscribe({
            next: retorno => {
                this.tiposAto = retorno;
                this.tiposAto.sort((a, b) => a.nomeTipoAto > b.nomeTipoAto ? 1 : -1);
            },
            error: () => null
        });
    }

    private carregarAssuntos() {
        this.assuntoService.listar().subscribe({
            next: retorno => {
                this.assuntos = retorno;
                this.labelsAssunto = this.assuntos.map(t => t.nomeAssunto);
            },
            error: () => null
        });
    }

    private carregarOrgaos() {
        this.orgaoService.getTodos().subscribe({
            next: retorno => {
                this.orgaos = retorno;
                this.orgaos.sort((a, b) => a.siglaOrgao > b.siglaOrgao ? 1 : -1);
                this.orgaos.forEach(o => o.label = o.siglaOrgao + " - " + o.nomeOrgao);
            },
            error: () => null
        });
    }

    public limpar() {
        this.alertMessageService.dismissAll();
        this.pesquisaAvancada = false;
        this.filtro = new BuscaAto();
        this.listaTipoAtoSelecionada = [];
        this.listaOrgaosSelecionados = [];
        this.listaAssuntosSelecionados = [];
        this.listaAreasResponsaveisSelecionadas = [];
        this.atos = [];
        this.atosOriginais = [];
        this.resetSortedBy();
    }

    public buscar(limparMensagens: boolean) {

        if (limparMensagens) {
            this.alertMessageService.dismissAll();
        }

        // Campo usado apenas para consulta dos atos do dia
        this.filtro.dataPublicacaoStr = undefined;

        // Se o id é informado, descarta os demais parametros
        if (this.filtro.idAto && this.filtro.idAto > 0) {

            const idAto = this.filtro.idAto;
            this.filtro = new BuscaAto();
            this.filtro.idAto = idAto;

        } else {    // Caso o id não seja informado...

            // Tipos de Ato selecionados
            if (this.listaTipoAtoSelecionada && this.listaTipoAtoSelecionada.length > 0) {
                this.filtro.listaIdsTipoAto = this.listaTipoAtoSelecionada.map(ta => ta.idTipoAto);
            } else {
                this.filtro.listaIdsTipoAto = undefined;
            }

            // Orgaos selecionados
            if (this.listaOrgaosSelecionados && this.listaOrgaosSelecionados.length > 0) {
                this.filtro.listaIdsOrgao = this.listaOrgaosSelecionados.map(o => o.idOrgao);
            } else {
                this.filtro.listaIdsOrgao = undefined;
            }

            // Assuntos selecionados
            if (this.listaAssuntosSelecionados && this.listaAssuntosSelecionados.length > 0) {
                this.filtro.listaIdsAssunto = this.listaAssuntosSelecionados.map(a => a.idAssunto);
            } else {
                this.filtro.listaIdsAssunto = undefined;
            }

            // Áreas Responsáveis selecionadas
            if (this.listaAreasResponsaveisSelecionadas && this.listaAreasResponsaveisSelecionadas.length > 0) {
                this.filtro.listaIdsAreaResponsavel = this.listaAreasResponsaveisSelecionadas.map(ar => ar.idOrgao);
            } else {
                this.filtro.listaIdsAreaResponsavel = undefined;
            }

            this.filtro.numeroAto = this.getStringOrUndefined(this.filtro.numeroAto);
            this.filtro.textoLivre = this.getStringOrUndefined(this.filtro.textoLivre);
            this.filtro.secao = this.getStringOrUndefined(this.filtro.secao);
            this.filtro.numeroPagina = this.getNumberOrUndefined(this.filtro.numeroPagina);
        }

        this.buscarPorFiltro();
    }

    public buscarAtosDeHoje() {

        this.alertMessageService.dismissAll();

        // Só usa a data de publicação
        this.filtro = new BuscaAto();
        this.filtro.dataPublicacaoStr = DataUtil.getDataStrHoje();

        this.buscarPorFiltro();
    }

    private buscarPorFiltro() {

        this.filtro.converterDatasStr();

        this.loadingService.show();

        this.atoService.buscarPorFiltro(this.filtro).subscribe({
            next: retorno => {
                this.resetSortedBy();
                this.atosOriginais = retorno;
                this.atos = retorno;
                if (this.atos.length == 0) {
                    this.alertMessageService.warn('A consulta não retornou resultados.');
                } else {
                    this.exibirEmentaTela = this.filtro.exibirEmenta;
                    this.subirParaTopoResultado();
                }
                this.loadingService.hide();
            },
            error: () => this.loadingService.hide()
        });
    }

    public getEmenta(ementa: string): string {
        const MAX_CARACTERES_EMENTA = 30;
        if (ementa && ementa.length > MAX_CARACTERES_EMENTA) {
            return ementa.substring(0, MAX_CARACTERES_EMENTA) + "...";
        }
        return ementa;
    }

    private resetSortedBy() {
        for (let i = 0; i < this.sortedBy.length; i++) {
            this.sortedBy[i] = undefined;
        }
    }

    private getStringOrUndefined(texto: string | undefined): string | undefined {
        texto = texto?.trim();
        if (!texto || texto.length == 0) {
            return undefined;
        }
        return texto;
    }

    private getNumberOrUndefined(numero: number | undefined): number | undefined {
        if (!numero || numero === 0) {
            return undefined;
        }
        return numero;
    }

    public sortByColuna(indice: number, asc: boolean) {
        this.resetSortedBy();
        this.sortedBy[indice] = asc;
        const lista = this.listaVazia.concat(this.atosOriginais);
        if (asc != undefined) {
            lista.sort(AtoConsulta.getFunctionSortBy(this.sortedColumn[indice]));
            if (asc == false) {
                lista.reverse();
            }
        }
        this.atos = lista;
    }

    subirParaTopoResultado() {
        const element = document.getElementById('ancora');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    public onChangeLocal(event: any) {
        this.filtro.idLocalPublicacao = parseInt(event.srcElement.value);
        if (this.filtro.idLocalPublicacao !== 4) {
            this.filtro.textoLivre = undefined;
        }
        if (this.filtro.idLocalPublicacao !== 1 && this.filtro.idLocalPublicacao !== 3) {
            this.filtro.secao = undefined;
            this.filtro.numeroPagina = undefined;
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onChangeTipoVisao(event: any) {
        this.filtro.tipoVisao = parseInt(event.srcElement.value);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onChangeSituacao(event: any) {
        this.filtro.situacao = parseInt(event.srcElement.value);
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
    onChangeVisao(event: any, indice: number) {
        // os checkboxes das Visões formam uma sequência de 4 bits, exemplo '0110', a armazenar como string em this.ato.exibirVisoes
        const bit = event.srcElement.checked ? '1' : '0';
        let s = this.filtro.exibirVisoes;
        s = s.substring(0, indice) + bit + s.substring(indice + 1, 4);
        this.filtro.exibirVisoes = s;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onChangeExibirEmenta(event: any) {
        this.filtro.exibirEmenta = event.srcElement.value === "1";
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onChangeExibirInternet(event: any) {
        this.filtro.exibicaoInternet = parseInt(event.srcElement.value);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public onChangeExibirSijut1(event: any) {
        this.filtro.exibicaoSijut1 = parseInt(event.srcElement.value);
    }

    repetirDataAto() {
        this.filtro.dataAtoFinal = this.filtro.dataAtoInicial;
    }

    repetirDataPublicacao() {
        this.filtro.dataPublicacaoFinal = this.filtro.dataPublicacaoInicial;
    }

    repetirDataInicioVigencia() {
        this.filtro.dataInicioVigenciaFinal = this.filtro.dataInicioVigenciaInicial;
    }

    repetirDataFimVigencia() {
        this.filtro.dataFimVigenciaFinal = this.filtro.dataFimVigenciaInicial;
    }

    excluirRepulicacao(ato: AtoConsulta): void {

        this.alertMessageService.dismissAll();
        this.loadingService.show();

        this.atoService.excluirRepublicacaoAto(ato.idAto).subscribe({
            next: retorno => {
                if (retorno.codigo == 0) {
                    this.alertMessageService.info('Sucesso', 'Exclusão da republicação efetuada com sucesso.');
                    // this.buscar(false);
                    this.buscarPorFiltro();
                } else {
                    this.alertMessageService.warn('Erro', retorno.mensagem);
                }
                this.loadingService.hide();
            },
            error: () => this.loadingService.hide()
        });
    }

    visualizarAto(ato: Ato) {
        const listaVSBase64 = this.gerarListaBase64VisualizacaoSequencial();
        let hashParaUrl = '';
        if (listaVSBase64 && this.atos.length > 1) {
            hashParaUrl = '/vs/' + listaVSBase64;
        }
        const url = `${window.location.origin}/#` + `${appRoute.ato.visualizarAto}/${ato.idAto}${hashParaUrl}`;
        window.open(url, '_blank');
    }

    /**
     * Retorna uma string codificada em Base 64 com a lista de ids separados por vírgula.
     */
    private gerarListaBase64VisualizacaoSequencial(): string {
        const listaIdsAtosVisualizSeq = this.gerarListaIdsAtosConsulta();
        const listaIdsAtosVisualizSeqStr = listaIdsAtosVisualizSeq.join(',');
        return btoa(listaIdsAtosVisualizSeqStr);
    }

    /**
     * Retorna uma lista com os Ids dos os atos da página atual.
     */
    private gerarListaIdsAtosConsulta(): number[] {
        const pipe: CurrentPagePipe = new CurrentPagePipe();
        const atosPagina = pipe.transform(this.atos, this.currentPage);
        return atosPagina ? atosPagina.map(a => a.idAto) : [];
    }

    public verAtosDeHoje() {
        this.buscarAtosDeHoje();
    }
}
